// ─────────────────────────────────────────────────────────────────────
// /workflows — launcher page for the General SS White section.
// Renders the MenuHub component which handles the 2-level drill-down
// (workflow cards → sub-action cards).
// ─────────────────────────────────────────────────────────────────────
import React from "react";
import { Container } from "reactstrap";
import MenuHub from "../../Components/Common/MenuHub";

const WorkflowsLauncher = () => {
    document.title = "Workflows | SSW Technologies";
    return (
        <div className="page-content">
            <Container fluid>
                <MenuHub />
            </Container>
        </div>
    );
};

export default WorkflowsLauncher;
